import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Image, View } from 'react-native';
import { TouchableOpacity, TWCText } from '@components';
import { useRecoilState } from 'recoil';

import { settingsMenuTestIDs, settingsPageTestIDs, Theme } from '@constants';
import { useContextNodeHandle, useContextReference } from '@hooks';
import { userSettingsState } from '@store';

import { styles } from './styles';

import ToggleOnIcon from '../../../assets/icons/editIcons/toggle-on.png';
import { FocusableSwitch } from '../../focusable/FocusableSwitch/FocusableSwitch';

export const SettingsClosedCaptioning: FC = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'settingsPage.closedCaptioning',
  });
  const [{ closedCaptionsEnabled }, setUserSettings] = useRecoilState(userSettingsState);

  const settingsClosedCaptioningSwitchReference = useContextReference<TouchableOpacity>(
    settingsPageTestIDs.closedCaptioning.settingsClosedCaptioningSwitch,
  );
  const closedCaptioningMenuHandle = useContextNodeHandle(settingsMenuTestIDs.closedCaptioning);

  const handleValueChange = () => {
    setUserSettings(oldState => ({
      ...oldState,
      closedCaptionsEnabled: !closedCaptionsEnabled,
    }));
  };

  return (
    <View style={styles.settingsClosedCaptioningWrapper}>
      <TWCText
        style={styles.settingsClosedCaptioningTopContent}
        testID={settingsPageTestIDs.closedCaptioning.settingsClosedCaptioningText}
        variant={'regularText36'}
      >
        {closedCaptionsEnabled ? t('closedCaptioningTextOn') : t('closedCaptioningTextOff')}
      </TWCText>
      <FocusableSwitch
        accessibilityHint={t('switchAccessibilityHint')}
        accessibilityLabel={
          closedCaptionsEnabled ? t('switchAccessibilityLabelEnabled') : t('switchAccessibilityLabelDisabled')
        }
        activeText={t('switchActiveText')}
        backgroundActive={Theme.switch.activeColor}
        backgroundInactive={Theme.switch.inactiveColor}
        barHeight={Theme.px(80)}
        changeValueImmediately
        circleBorderWidth={0}
        circleSize={Theme.px(54)}
        colorFocused={Theme.switch.focusColor}
        inActiveText={t('switchInactiveText')}
        nativeID={settingsPageTestIDs.closedCaptioning.settingsClosedCaptioningSwitch}
        nextFocusDown={undefined}
        nextFocusLeft={closedCaptioningMenuHandle}
        nextFocusRight={undefined}
        nextFocusUp={undefined}
        ref={settingsClosedCaptioningSwitchReference}
        renderInsideCircle={() =>
          closedCaptionsEnabled ? <Image source={ToggleOnIcon} style={styles.checkIcon} /> : <></>
        }
        switchLeftPx={2}
        switchRightPx={2}
        switchWidthMultiplier={3.15}
        testID={settingsPageTestIDs.closedCaptioning.settingsClosedCaptioningSwitch}
        value={closedCaptionsEnabled}
        onValueChange={handleValueChange}
      />
    </View>
  );
};
